"use client";

import { useCallback } from "react";
import { trackRybbitEvent, trackRybbitEventBeacon } from "../rybbit";

// Umami 已于 2026-10-31 停用，事件只发 Rybbit。名字先留着，免得动 22 个调用点。
// Rybbit 脚本发事件带 keepalive，跳转（比如去 checkout）不会把请求掐掉，
// 所以直接 resolve；保留 Promise 是因为调用方会 await。
export function trackUmamiEvent(
	event: string,
	data?: Record<string, unknown>,
): Promise<unknown> {
	if (typeof window === "undefined") {
		return Promise.resolve();
	}

	trackRybbitEvent(event, data);
	return Promise.resolve();
}

// global-error 换掉了根 layout，脚本不会再加载，直接 POST 到收数接口。
// 返回是否发成功，调用方据此决定要不要保留重试凭据（比如注册回执 cookie）
export function trackUmamiEventBeacon(
	event: string,
	data?: Record<string, unknown>,
): Promise<boolean> {
	return trackRybbitEventBeacon(event, data);
}

export function useAnalytics() {
	// Stable identity: callers put this in useEffect deps, and an unstable one
	// re-fires their event on every render.
	const trackEvent = useCallback(trackUmamiEvent, []);

	return {
		trackEvent,
	};
}
